/**
 * The founder's direct line, shown to people signing up or on a trial.
 *
 * One value. The display form and the `tel:` / `sms:` targets are derived
 * from it, so a number change does not leave a stale link behind.
 */
export const FOUNDER_PHONE_E164 = '+15852006753';

const NANP = /^\+1(\d{3})(\d{3})(\d{4})$/;

/** "(585) 200-6753". Anything that is not a US number stays in E.164. */
export function founderPhoneDisplay(e164: string = FOUNDER_PHONE_E164): string {
  const match = NANP.exec(e164);
  if (!match) return e164;
  return `(${match[1]}) ${match[2]}-${match[3]}`;
}

export const FOUNDER_PHONE_DISPLAY = founderPhoneDisplay();

export const FOUNDER_PHONE_TEL = `tel:${FOUNDER_PHONE_E164}`;

export const FOUNDER_PHONE_SMS = `sms:${FOUNDER_PHONE_E164}`;

export type FounderContactLanguage = 'en' | 'es';

/**
 * Plain-text lines for owner emails.
 *
 * The `tel:` and `sms:` URIs are what a phone opens when the line is tapped.
 * No response-time promise: the line only says the number can be called or
 * texted.
 */
export function founderContactEmailLines(language: FounderContactLanguage): string[] {
  const display = FOUNDER_PHONE_DISPLAY;
  if (language === 'es') {
    return [
      `¿Preguntas? Llame o envíe un mensaje de texto al ${display}.`,
      `Llame al ${display}: ${FOUNDER_PHONE_TEL}`,
      `Envíe un mensaje de texto al ${display}: ${FOUNDER_PHONE_SMS}`,
    ];
  }
  return [
    `Questions? Call or text ${display}.`,
    `Call ${display}: ${FOUNDER_PHONE_TEL}`,
    `Text ${display}: ${FOUNDER_PHONE_SMS}`,
  ];
}
